import { Component, Input, OnInit, ViewEncapsulation, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'accordion',
    templateUrl: './accordion.html',
    encapsulation: ViewEncapsulation.None
})
export class AccordionComponent implements OnInit {
    @Output() onChangedState = new EventEmitter<boolean>();
    @Input() title: string;
    @Input() isHide: boolean;
    btnClass: string;

    ngOnInit() {
        this.setIcon();
    }

    onClickAccord() {
        this.isHide = !this.isHide;
        this.setIcon();

        if (this.onChangedState) {
            setTimeout(() => this.onChangedState.emit(!this.isHide), 100);
        }
    }

    setIcon() {
        if (this.isHide)
            //this.btnClass = "circle-bg fas fa-angle-right";
            this.btnClass = "accordion-bg fas fa-arrow-alt-circle-right";
        else
            //this.btnClass = "circle-bg fas fa-angle-down";
            this.btnClass = "accordion-bg fas fa-arrow-alt-circle-down";
    }
}
